import { useTranslation } from "react-i18next";
import { NumberedCard } from "@/components/NumberedCard";
import { Button } from "@/components/Button";
import SendolaBlackLogo from "@/assets/Img/sendola-black-white-logo.png";
import WomanSmilingPhone from "@/assets/Img/woman-smiling-on-the-phone.jpg";

export const PremiumServiceBanner = () => {
  const [tBusiness] = useTranslation("business");

  return (
    <>
      <div className="flex flex-col md:flex-row w-full gap-10 max-w-screen-xl">
        <div className="flex min-w-72 flex-col items-center justify-center gap-8 sm:gap-14 col-span-2">
          <div>
            <img className="h-16 object-contain" src={SendolaBlackLogo} />
            <p className="text-lg text-center font-extralight text-stone-400 leading-3">
              Premium Service
            </p>
          </div>
          <p
            className="md:hidden max-w-[28rem] text-3xl text-center text-business-green inner-span-semibold font-light"
            dangerouslySetInnerHTML={{
              __html: tBusiness("HigherLevel.Title"),
            }}
          />
          <img
            className="h-32 xs:h-44 sm:h-80 w-full sm:w-80 rounded-3xl object-cover object-top sm:object-right scale-x-[-1] max-sm:shadow-2xl"
            src={WomanSmilingPhone}
          />
        </div>
        <div className="flex flex-col justify-center gap-4 col-span-3 text-sendolab-white2">
          <div className="hidden sm:block">
            <p
              className="text-xl md:text-2xl text-business-green inner-span-semibold font-light"
              dangerouslySetInnerHTML={{
                __html: tBusiness("HigherLevel.Title"),
              }}
            />
            <p className="font-light">{tBusiness("HigherLevel.Subtitle")}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 sm:mt- place-items-center">
            <NumberedCard
              className="px-6 py-4 text-sm min-h-20 w-full max-sm:w-[90%]"
              text={tBusiness("HigherLevel.Cards.Card1")}
            />
            <NumberedCard
              className="px-6 py-4 text-sm min-h-20 w-full max-sm:w-[90%]"
              text={tBusiness("HigherLevel.Cards.Card2")}
            />
            <NumberedCard
              className="px-6 py-4 text-sm min-h-20 w-full max-sm:w-[90%]"
              text={tBusiness("HigherLevel.Cards.Card3")}
            />
            <NumberedCard
              className="px-6 py-4 text-sm min-h-20 w-full max-sm:w-[90%]"
              text={tBusiness("HigherLevel.Cards.Card4")}
            />
          </div>

          <p className="text-2xl max-sm:text-center text-business-green inner-span-semibold font-light max-sm:mt-10">
            {tBusiness("HigherLevel.Title2")}
          </p>
          <p className="font-light max-sm:text-center">
            {tBusiness("HigherLevel.Paragraph1")}
          </p>

          <div className="flex justify-center sm:justify-start items-center">
            <Button
              className="bg-white !border-0 !px-4 !text-black hover:bg-gray-200 !font-light mt-2"
              variant="secondary"
              size="sm"
              text={tBusiness("Buttons.ContactUs")}
              link="/business/contact"
            />
          </div>
        </div>
      </div>
    </>
  );
};
